<template>
  <div class="hm-card" :class="($template === 'article') ? 'article' : 'small'">
    <div class="max-w">
      <h2>
        Do You Have Medicaid?
        <span class="tooltip-icon" v-tooltip="'This is a joint federal and state program that helps with medical costs for citizens with limited income and resources. Most costs are covered if you qualify for Medicare and Medicaid.'">
          <img src="//hm-lis.herokuapp.com/img/svg/info-circle-solid.svg" alt="image">
        </span>
      </h2>
      <p>If you and/or your spouse have coverage through your state’s Medicaid program, select “I Have Medicaid”.</p>
    </div>
    <SuiDivider inverted v-if="($template === 'small')"/>
    <div class="max-w">
      <div
        :class="{ 'large-icons-block': ($template === 'article') }">
        <SuiButton
          basic
          color="grey"
          class="large-icon full-width"
          @mouseover="checkOn = 'check_on_green'"
          @mouseleave="checkOn = 'check_on'"
          :class="{ 'article': ($template === 'article') }"
          @click="onClickHasMedicaid">
          <img :src="`//hm-lis.herokuapp.com/img/svg/${checkOn}.svg`" alt="image" class="large-icon">
          <span>I Have Medicaid</span>
        </SuiButton>
        <SuiButton
          basic
          color="grey"
          class="large-icon full-width"
          @mouseover="checkOff = 'check_off_green'"
          @mouseleave="checkOff = 'check_off'"
          :class="{ 'article': ($template === 'article') }"
          @click="onClickDontHasMedicaid">
          <img :src="`//hm-lis.herokuapp.com/img/svg/${checkOff}.svg`" alt="image" class="large-icon">
          <span>I Do Not Have Medicaid</span>
        </SuiButton>
      </div>
    </div>
  </div>
</template>

<script>
  import {Button} from 'semantic-ui-vue/dist/commonjs/elements/Button';
  import {Divider} from 'semantic-ui-vue/dist/commonjs/elements/Divider';

  export default {
    name: 'Medicaid',
    components: {
      SuiButton: Button,
      SuiDivider: Divider,
    },
    data() {
      return {
        checkOn: 'check_on',
        checkOff: 'check_off',
      }
    },
    methods: {
      onClickHasMedicaid() {
        this.$store.commit('setHasMedicaid', true);
        this.goNextStep('final');
      },
      onClickDontHasMedicaid() {
        this.goNextStep('extra-help');
      },
      goNextStep(step) {
        this.$store.commit('setStep', step);
        if (this.$template == 'landing') {
          window.scrollTo(0,0);
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

  .large-icon:hover {
    .check-off {
      background-image: url('//hm-lis.herokuapp.com/img/svg/check_off_green.svg');
    }
    .check-on {
      background-image: url('//hm-lis.herokuapp.com/img/svg/check_on_green.svg');
    }
  }
  .check-on {
    background-image: url('//hm-lis.herokuapp.com/img/svg/check_on.svg');
  }
  .check-off {
    background-image: url('//hm-lis.herokuapp.com/img/svg/check_off.svg');
  }

</style>
